import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, TextField, Typography } from "@mui/material";
import { Button, DateField, EmailField, FunctionField, Labeled, required, SimpleShowLayout, TopToolbar, useGetOne, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { cleanRangeChoices, getAllowance, getNameAndCompanyNamewithAddress, getStaffNum } from "../common";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const CleanHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  const { id } = useParams();
  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("cleanHistory", { id });
  useEffect(() => {
    if (!isLoading && data) {
      setRecord(data);
      fetchCustomers();
    }
  }, [data, isLoading]);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
        mode: "cors",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      const { data } = await response.json();
      setCustomers(data);
    } catch (error) {
      console.error("ユーザー情報の取得に失敗しました:", error);
    } finally {
      // setLoading(false);
    }
  };

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
      <TopToolbar>
        <Button
          label="請求書を作成"
          onClick={() => redirect(`/invoice-form/cleanHistory/${id}`)}
          startIcon={<NoteAddIcon />}
        />
        <Button
          label="清掃情報編集"
          onClick={() => redirect(`/cleanHistory/${id}`)}
          startIcon={<EditIcon />}
        />
      </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  return (
    <>
      <CustomTopToolbar />
      <Card>
        <CardContent>
          <SimpleShowLayout record={record}>
            {/* <FunctionField source="number" label={labelStyle("清掃No")} style={{ paddingLeft: "5px" }} render={(record) => {
                  return String(record.number).padStart(5, "0");
                }}/> */}
            <DateField source="cleaningDate" label={labelStyle("清掃日")} style={{ paddingLeft: "5px" }} />
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Labeled label={labelStyle("汲取予定量【㎥】")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField source="pumpingAmount" label={labelStyle("汲取予定量【㎥】")} style={{ paddingLeft: "5px" }} render={record => { return record.pumpingAmount ? record.pumpingAmount.toLocaleString() : "" }} />
              </Labeled>
              <Labeled label={labelStyle("汲取実量(請求量)【㎥】")} style={{ flex: 1 }}>
                <FunctionField source="pumpingWeigh" label={labelStyle("汲取実量(請求量)【㎥】")} style={{ paddingLeft: "5px" }} render={record => { return record.pumpingWeigh ? record.pumpingWeigh.toLocaleString() : "" }} />
              </Labeled>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Labeled label={labelStyle("汲取金額")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField source="pumpingPay" label={labelStyle("汲取金額")} style={{ paddingLeft: "5px" }} render={record => { return record.pumpingPay ? record.pumpingPay.toLocaleString() + "円" : "" }} />
              </Labeled>
              <Labeled label={labelStyle("清掃範囲")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField
                  label={labelStyle("清掃範囲")}
                  render={record => {
                    const choice = cleanRangeChoices.find(choice => choice.id === record.cleanRange);
                    return choice ? choice.name : "";
                  }}
                />
              </Labeled>
              <Labeled label={labelStyle("担当者名")} style={{ flex: 1 }}>
                <FunctionField label={labelStyle("担当者名")} style={{ paddingLeft: "5px" }} render={record => { return `${record.staffName ?? ""}・${record.staffName2 ?? ""}` }} />
              </Labeled>
            </div>
            <FunctionField
              label={labelStyle("手当")}
              render={record => {
                return `${(getAllowance(record.pumpingAmount, getStaffNum(record))).toLocaleString()}円`;
              }}
            />
            <FunctionField source="content" label={labelStyle("清掃内容")} style={{ paddingLeft: "5px" }} render={record => { return record.content }} />
            <FunctionField
              source="customerId"
              label={labelStyle("顧客名")}
              style={{ paddingLeft: "5px" }}
              render={(record) => {
                const customer = customers.find(cust => cust.id === record.customerId);
                return <Link to={`/customers-clean/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(customer)}</Link>;
              }}
            />
            <FunctionField
              source="invoiceId"
              label={labelStyle("請求情報")}
              style={{ paddingLeft: "5px" }}
              render={(record) => {
                // return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && String(record.invoiceNumber).padStart(5, "0")}</Link>;
                return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求詳細はこちら</>}</Link>;
              }}
            />
            <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
            <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />

          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default CleanHistoryShow;

